import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { FilterType } from '@app/shared/interfaces/front-end-column';
import { FilterOperator } from '@product/shared/models/Enums.enum';
import { FilterObject, ListPayload } from '@product/shared/models/ListPayload';
import { Product } from '@product/shared/models/product';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { catchError, of, tap } from 'rxjs';

@Component({
  selector: 'app-product-selector',
  templateUrl: './product-selector.component.html',
  styleUrls: ['./product-selector.component.less']
})
export class ProductSelectorComponent  extends BaseComponent  {
  @Input() productId?:number=0;
  @Input() preSelectedProducts: Set<Product> = new Set();

  @ViewChild('productsDrawerTemplate', { static: false })
  productsDrawerTemplate: TemplateRef<any>;
  @ViewChild('recordsDrawerFooter') recordsDrawerFooter: TemplateRef<any>;
  @Input() listColumns: any;
  @Input() productsPayload: ListPayload;
  @Input() savedFilters: { [key: string]: FilterObject } | null = {};

  @Output() productsSelected = new EventEmitter<Product[]>();
  @Output() filtersChanged = new EventEmitter<{ [key: string]: FilterObject }>();

  tempSelectedProducts = new Set<Product>();
  
  modalRecords: Product[] = [];
  totalProductsCount = 0;
 override isLoading = false;
  private tempProductsDrawerRef: NzDrawerRef;
  
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['savedFilters'] && !changes['savedFilters'].firstChange) {
      this.productsPayload.Filters = { ...this.savedFilters }; 
      // this.getModalProducts();
      this.validateAndSendPayload();
    }
    if (changes['preSelectedProducts']) {
      this.tempSelectedProducts = new Set(this.preSelectedProducts);
    }
  }
  
  
  

  openDrawer() {
   
    this.tempSelectedProducts = new Set(this.preSelectedProducts);
    this.tempProductsDrawerRef = this.drawerService.create({
      nzTitle: 'Choose products to add',
      nzContent: this.productsDrawerTemplate,
      nzWidth: '90%',
      nzFooter: this.recordsDrawerFooter,
    });

    
    this.validateAndSendPayload();
  }
  getModalProducts() {
    const excludedProductId=this.productId;
  this.isLoading = true;
    this.commonService
      .getProducts(this.productsPayload)
      .pipe(
        tap((response) => {
          this.modalRecords = response.records.filter(product=>product.id!==excludedProductId);
          this.totalProductsCount = response.recordsCount;
          this.isLoading = false;
        }),
        catchError((error) => {
          console.error('Error fetching products:', error.error.errors || error.message);
          this.isLoading = false;
          return of([]);
        })
      )
      .subscribe();
  }

  onProductSelectionChange(selectedRecords: Set<Product>) {
    this.tempSelectedProducts = selectedRecords;

   //  this.productsSelected.emit(Array.from(this.tempSelectedProducts));
  }

  selectRows() {
    this.productsSelected.emit(Array.from(this.tempSelectedProducts));
    this.tempSelectedProducts.clear();
    this.tempProductsDrawerRef.close();
  }

  cancelSelection() {
    this.tempSelectedProducts.clear();
    this.tempProductsDrawerRef.close();
  }
  handleGetProducts(payload: ListPayload) {
    this.productsPayload = { ...payload }; 
    // this.getModalProducts();
    this.validateAndSendPayload();
}


validateAndSendPayload() {
 
 

  const validFilters: { [key: string]: FilterObject } = {};

  if (this.savedFilters && Object.keys(this.savedFilters).length > 0) {

    const code = this.savedFilters['code']; 
    const filter = this.savedFilters['filter'];


    if (filter && (filter.Value != null || filter.Type === 6)) {

      const fieldName = typeof code === 'string' ? code : "defaultField"; 


      validFilters[fieldName] = {
        AdditionalInfo: filter.AdditionalInfo ?? '{}',
        Operator: filter.Operator ?? FilterOperator.isEqual,
        Type: filter.Type ?? FilterType.String,
        Value: filter.Value ?? '' 
      };
    }
  }


  //this.productsPayload.Filters = validFilters;


  this.getModalProducts();
}


handleFiltersChanges(filter: any) {
  if (filter == null) return;
  // deleting the filter if the value was null or empty
  const additionalInfo = JSON.parse(filter.filter?.AdditionalInfo ?? '{}');
  if (
    (['', null, undefined, 'null'].includes(filter.filter?.Value?.trim()) &&
      additionalInfo.needValue == null) ||
    (additionalInfo.needValue != null && additionalInfo.needValue === true)
  ) {
    delete this.productsPayload.Filters[filter.code];
  }
  const keys = Object.keys(this.productsPayload.Filters);

  if (keys.includes(filter.code)) {
    this.productsPayload.Filters[filter.code] = filter.filter;
  } else if (
    !['', null, undefined, 'null'].includes(filter.filter?.Value) ||
    additionalInfo.needValue === false
  ) {
    this.productsPayload.Filters = {
      ...this.productsPayload.Filters,
      [filter.code]: filter.filter,
    };
  }
  this.getModalProducts();
}

}
